import { IIncentiveV2Store } from "@/domain/dto/store.incentive-v2.interfaces";
import { IncentiveStep } from "interfaces";
import { Ref } from "vue";

export default class RedirectToLogin {
	constructor(private store: IIncentiveV2Store, private readonly isRegister: Ref<boolean>) {}
	public redirectToLogin(): void {
		this.isRegister.value = false;
		this.store.mutations.setStep(IncentiveStep.LOGIN);
	}
}